// extracted by css-extract-rspack-plugin
export default {"disconnectedPullRequestLink":"DisconnectedEvent-module__disconnectedPullRequestLink__bQw8sYt"};